import Box from '@mui/material/Box';
import type { TSpaceBase } from '@onesource/schemas';
import { getSession, useGetAllProfileQuery } from '@onesource/services';
import { type FC } from 'react';

import WhosOnline from '#/components/whos-online';

import { formatCommunityTitle } from '../utils/community-title';
import { FeedPostsSkeleton } from './feed-posts-skeleton';
import { FeedTabContent } from './feed-tab-content';
import { SpaceNoAccessPage } from './space-no-access-page';

/**
 * Community feed for a FEED sub-space, rendered under the slug route
 * `/{program}/{subSpace}`. Access is keyed on the space's app (inherited from
 * the parent); locked members get the no-access page.
 */
export const SubSpaceCommunityView: FC<{ subSpace: TSpaceBase }> = ({ subSpace }) => {
  const token = getSession();
  const { data: profile, isLoading: isLoadingProfile } = useGetAllProfileQuery({ token });

  const spaceApp = subSpace.app ?? subSpace.parent?.app;
  const hasAccess = spaceApp ? !!profile?.access?.[spaceApp] : false;

  if (isLoadingProfile) {
    return (
      <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', md: 'row' } }}>
        <Box sx={{ flex: 1, maxWidth: { xs: '100%', md: 'calc(100% - 250px)' } }}>
          <FeedPostsSkeleton />
        </Box>
        <WhosOnline />
      </Box>
    );
  }

  if (!hasAccess) {
    return (
      <SpaceNoAccessPage
        name={formatCommunityTitle(subSpace.name, subSpace.parent?.name)}
        bannerImage={subSpace.bannerImage ?? null}
      />
    );
  }

  return <FeedTabContent subSpace={subSpace} parentSpace={subSpace} />;
};
